
import { lazy, Suspense } from 'react'
import { RouteObject } from 'react-router-dom'
import WelcomeRoutes from './account'
import { Spin } from 'antd'
import { get } from 'lodash'

const JiraStask = lazy(() => import("@/pages/account/jira"))
const EditJiraStack = lazy(() => import("@/pages/account/jira/edit"))
const JiraMilestoneStask = lazy(() => import("@/pages/account/jira/milestone"))
const CheckListStask = lazy(() => import("@/pages/account/checkList"))
const NotesStack = lazy(() => import("@/pages/account/notes"))
const BunkerMonitorStack = lazy(() => import("@/pages/account/bunkerMonitor"))
const MediaFilesStack = lazy(() => import("@/pages/account/mediaFiles"))
const IframeStack = lazy(() => import("@/pages/account/iframe"))
const SisterProfileListStack = lazy(() => import("@/pages/account/sisterProfileList"))
const InfoStack = lazy(() => import("@/pages/account/info"))
const ProjectStack = lazy(() => import("@/pages/account/project"))

export const ACCOUNT_ROUTERS: RouteObject[] = [
  {
    path: "/", 
    element: <WelcomeRoutes />,
    children: [
      {
        path: 'project',
        children: [
          {
            path: "list",
            element: <ProjectStack />,
          },
          {
            path: ':projectId',
            element: <JiraStask />,
          },
          {
            path: ":projectId/:id/edit",
            element: <EditJiraStack />
          },
          {
            path: ":projectId/milestone/:id",
            element: <JiraMilestoneStask />
          },
          {
            path: ":projectId/milestone/:id/edit",
            element: <EditJiraStack />
          },
        ]
      },
      {
        path: "check-list",
        element: <CheckListStask />
      },
      {
        path: "notes",
        element: <NotesStack />
      },
      {
        path: "media-files",
        element: <MediaFilesStack />
      },
      {
        path: "games",
        children: [
          {
            path: "iframe",
            element: <IframeStack />
          },
          {
            path: "bunkerMonitor",
            element: <BunkerMonitorStack />
          }
        ]
      },
      {
        path: 'sisterProfile',
        element: <SisterProfileListStack />
      },
      {
        path: 'info',
        element: <InfoStack />
      }
    ]
  }
]

export const RouteLoading = () => {
  return (
    <div 
      style={{ 
        display: "flex", 
        justifyContent: "center", 
        alignItems: "center" 
      }}
    >
      <Spin size="large" />
    </div>
  )
}

export function addSuspense(routes: RouteObject[]) {
  for (const item of routes) {
    item.element = (
      <Suspense fallback={<RouteLoading />}>
        {item.element}
      </Suspense>
    )
    if (get(item, 'children', []).length > 0) {
      if (item.children) {
        item.children = addSuspense(item.children)
      }
    }
  }
  return routes
}
